import styles from './LogoBasic.module.css';
import PropTypes from 'prop-types';

function LogoBasic({ backgroundImage, style = {}, id = '' }) {
  const styleOverrides = {};

  if (backgroundImage) {
    styleOverrides.backgroundImage = backgroundImage;
  }

  if (style) {
    Object.assign(styleOverrides, style);
  }

  return <div style={styleOverrides} id={id} className={styles.LogoBasic} />;
}

LogoBasic.propTypes = {
  backgroundImage: PropTypes.string,
  style: PropTypes.object,
  id: PropTypes.string,
};

export default LogoBasic;
